export default "__VITE_ASSET__QzYPbsIL__"